import { Pipe, PipeTransform } from '@angular/core';
const pipeMap = new Map<number, string>();
pipeMap.set(0x0000, "使用者");
pipeMap.set(0x0010, "員工");
pipeMap.set(0X0020, "網站管理員");
pipeMap.set(0XFFFF, "創世神");
@Pipe({
  name: 'accountType'
})
export class AccountTypePipe implements PipeTransform {
  //ng g pipe accountType #cli
  transform(value: any, args?: any): any {
    try {
      return pipeMap.get(parseInt(value));
    } catch (erro) {
      return `Unknow type ${value}`;
    }
  }
  public static getType(): any[] {
    let array = [];
    pipeMap.forEach((v, k) => {
      array.push({ n: v, v: k });
    });
    return array;
  }


}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/account-type.pipe.ts